//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.selections

import blazern.lexisoup.graphql.model.fragment.selections.TranslationsSetFieldsSelections
import blazern.lexisoup.graphql.model.type.GraphQLString
import blazern.lexisoup.graphql.model.type.LexicalItemDetail
import blazern.lexisoup.graphql.model.type.Query
import blazern.lexisoup.graphql.model.type.TranslationsSet
import com.apollographql.apollo.api.CompiledArgument
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CompiledFragment
import com.apollographql.apollo.api.CompiledSelection
import com.apollographql.apollo.api.CompiledVariable
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.notNull
import kotlin.collections.List

public object LexicalItemsFromPanLexQuerySelections {
  private val __translationsSet: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "__typename",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledFragment.Builder(
          typeCondition = "TranslationsSet",
          possibleTypesSet = setOf("TranslationsSet")
        ).selections(TranslationsSetFieldsSelections.__root)
        .build()
      )

  private val __onWordTranslations: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "source",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "translationsSet",
          type = TranslationsSet.type.notNull()
        ).selections(__translationsSet)
        .build()
      )

  private val __translationsSet1: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "__typename",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledFragment.Builder(
          typeCondition = "TranslationsSet",
          possibleTypesSet = setOf("TranslationsSet")
        ).selections(TranslationsSetFieldsSelections.__root)
        .build()
      )

  private val __onSynonyms: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "source",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "translationsSet",
          type = TranslationsSet.type.notNull()
        ).selections(__translationsSet1)
        .build()
      )

  private val __panlex: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "__typename",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledFragment.Builder(
          typeCondition = "WordTranslations",
          possibleTypesSet = setOf("WordTranslations")
        ).selections(__onWordTranslations)
        .build(),
        CompiledFragment.Builder(
          typeCondition = "Synonyms",
          possibleTypesSet = setOf("Synonyms")
        ).selections(__onSynonyms)
        .build()
      )

  public val __root: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "panlex",
          type = LexicalItemDetail.type.notNull().list().notNull()
        ).arguments(listOf(
          CompiledArgument.Builder(Query.__panlex_langFromIso3).value(CompiledVariable("langFromIso3")).build(),
          CompiledArgument.Builder(Query.__panlex_langToIso3).value(CompiledVariable("langToIso3")).build(),
          CompiledArgument.Builder(Query.__panlex_query).value(CompiledVariable("query")).build()
        ))
        .selections(__panlex)
        .build()
      )
}
